<div
  #host
  class="bg-muted relative flex h-full min-h-[480px] justify-start overflow-auto rounded-lg border p-6"
  [class.select-none]="dragging()"
  (click)="onBackgroundClick()"
  (pointerdown)="onBackgroundPointerDown($event)">
  <div
    #pageSheet
    class="relative mx-auto mt-5 shrink-0 shadow-lg"
    [style.background]="backgroundColor() ?? '#ffffff'"
    [style.width.px]="page().width * PX_PER_PT * scale()"
    [style.height.px]="page().height * PX_PER_PT * scale()">
    <app-page-ruler
      class="absolute bottom-full left-0 mb-0.5"
      [lengthPt]="page().width"
      [scale]="scale()"
      orientation="horizontal" />
    <app-page-ruler
      class="absolute top-0 right-full mr-0.5"
      [lengthPt]="page().height"
      [scale]="scale()"
      orientation="vertical" />
    @if (previewSrc()) {
      <!-- The raster is the page: stretch it so rounding to whole pixels leaves no
           hairline of white at an edge. -->
      <app-authenticated-image
        class="pointer-events-none absolute inset-0 h-full w-full select-none"
        [src]="previewSrc()"
        fit="fill"
        alt="Hintergrund des Designs" />
    }
    <div
      class="absolute top-0 left-0 origin-top-left"
      [style.width.pt]="page().width"
      [style.height.pt]="page().height"
      [style.transform]="'scale(' + scale() + ')'">
      @for (element of elements(); track element.id) {
        <app-canvas-element
          [element]="element"
          [entry]="entryFor(element)"
          [placeholders]="placeholders()"
          [fontCss]="fontCss()"
          [imageSrc]="imageSrcFor()(element)"
          [longTexts]="longTexts()"
          [selected]="selectedIds().has(element.id)"
          [showHandles]="element.id === singleSelectedId()"
          [snapTarget]="snapTargets().has(element.id)"
          [issues]="issuesByElement().get(element.id) ?? null"
          [outlined]="outlines()"
          [editing]="element.id === editingId()"
          [selectAll]="element.id === editingId() && editSelectAll()"
          [scale]="scale()"
          (select)="select.emit($event)"
          (editStart)="editStart.emit($event)"
          (editEnd)="editEnd.emit()"
          (contentChange)="contentChange.emit($event)"
          (nudge)="nudge.emit($event)"
          (remove)="remove.emit($event)"
          (pointerStart)="onPointerStart($event)"
          (keyResize)="onKeyResize($event)" />
      }
      @if (selectionBox(); as box) {
        <div
          class="selection-box"
          aria-hidden="true"
          [style.left.pt]="box.x"
          [style.top.pt]="box.y"
          [style.width.pt]="box.width"
          [style.height.pt]="box.height"></div>
      }
      @if (groupBox(); as box) {
        <div
          class="group-box"
          aria-hidden="true"
          [style.left.pt]="box.x"
          [style.top.pt]="box.y"
          [style.width.pt]="box.width"
          [style.height.pt]="box.height">
          <span class="group-label" [style]="'transform: scale(' + 1 / (scale() * PX_PER_PT) + ')'"
            >Gruppe</span
          >
        </div>
      }
      @if (marquee(); as box) {
        <div
          class="marquee"
          aria-hidden="true"
          [style.left.pt]="box.x"
          [style.top.pt]="box.y"
          [style.width.pt]="box.width"
          [style.height.pt]="box.height"></div>
      }
    </div>
    <!-- Smart guides: outside the scaled layer, so lines and labels stay crisp at any zoom. -->
    @for (x of guides().x; track x) {
      <div class="guide guide-v" aria-hidden="true" [style.left.px]="x * PX_PER_PT * scale()">
        <span class="guide-cap guide-cap-top"></span>
        <span class="guide-cap guide-cap-bottom"></span>
      </div>
    }
    @for (y of guides().y; track y) {
      <div class="guide guide-h" aria-hidden="true" [style.top.px]="y * PX_PER_PT * scale()">
        <span class="guide-cap guide-cap-left"></span>
        <span class="guide-cap guide-cap-right"></span>
      </div>
    }
    @if (elements().length === 0) {
      <p
        hlmMuted
        class="pointer-events-none absolute inset-x-4 top-4 rounded bg-white/80 p-2 text-center text-sm">
        Füge links ein Element hinzu oder platziere alle Pflichtelemente auf einmal.
      </p>
    }
  </div>
</div>
